/* eslint-disable */
// import '../scss/style.scss';
// import '../scss/salonAdmin/style.scss';

import $ from 'jquery';
import './lib/spNav';
import './lib/accordion';
import './lib/createLi';
import './lib/more-accordion';
import './lib/payment-intent-accordion';
import './lib/splide';
import './lib/dialog';
import './lib/product';
import './lib/tab';


$(function() {
    // console.log('Script!');
});

window.onload = function () {
    // console.log('Script after!');
};
